import * as React from 'react';
import CustomLink from '../custom-link';
import HtmlContent from '../html-content';

function Note({ title, noteParagraph, linkText, linkHref }: NoteProps) {
    return (
        <div data-testid="note" className="note">
            {title && <h4>{title}</h4>}
            <p className="note__paragraph p--small">
                <HtmlContent html={noteParagraph} />
                {linkText && linkHref && <CustomLink text={linkText} hasUnderline hasIcon url={linkHref} />}
            </p>
        </div>
    );
}

export default React.memo(Note);
